export function transformReviews(oldReviews) {
  return oldReviews.map(r => ({
    reviewId: r.name || null,
    reviewer: {
      profilePhotoUrl: r.authorAttribution?.photoUri || "",
      displayName: r.authorAttribution?.displayName || "Anonymous",
      isAnonymous: !r.authorAttribution?.displayName
    },
    starRating: r.rating ?? null,
    comment: r.text?.text || "",
    createTime: r.publishTime || null,
    updateTime: r.publishTime || null, // Google reviews don’t expose separate update time, so reuse publishTime
    reviewReply: null // placeholder, since Google Places doesn’t include owner replies in this payload
  }));
}
